<template>
    <Tag :color="color">
        {{text}}
    </Tag>
</template>

<script>
    /**
     * 帐号状态的显示
     */
    export default {
        name: 'LyAccountStatus',
        props: {
            value: {
                type: [String, Number, Boolean],
                default: ''
            }
        },
        data () {
            return {
                color: 'primary'
            }
        },
        computed: {
            text () {
                let str = '未封禁'
                switch (this.value) {
                    case 1:
                        str = '未封禁'
                        this.color = 'primary'
                    break;
                    case 2:
                        str = '已封禁'
                        this.color = 'error'
                    break;
                }
                return str
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ../projectCore/src/components/account-status/src/index.vue